import OnlyAdmin from 'components/guards/OnlyAdmin';
import OnlyChecker from 'components/guards/OnlyChecker';
import OnlyHost from 'components/guards/OnlyHost';
import OnlyPromoter from 'components/guards/OnlyPromoter';
import { RolesSystem } from "lib/enums/RolesSystem.enum";
import { RouteTo } from 'lib/utils/routing';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from 'reactstrap';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UserDucks from 'stores/ducks/User.duck';

class TableContent extends React.Component<{ [label: string]: any }, { [label: string]: any }> {
    constructor(props) {
        super(props)
        this.state = {
            timeInfo: {
                startYear: 0,
                startMonth: 0,
                startDay: 0,
                startHour: 0,
                startMinutes: 0,
                startAMPM: 0,
                endYear: 0,
                endMonth: 0,
                endDay: 0,
                endHour: 0,
                endMinutes: 0,
                endAMPM: 0
            }
        }
    }

    public componentDidMount() {
        fetchGraphQL(
            `
			query {
				time {
					findByEventId(id:"${this.props.event.id}") {
						startYear
						startMonth
						startDay
						startHour
						startMinutes
						startAMPM
						endYear
						endMonth
						endDay
						endHour
						endMinutes
						endAMPM
					}
				}
			}
			`).then((res => {
                this.setState({ timeInfo: res.time.findByEventId });
            }))
    }

    public render() {
        const { timeInfo } = this.state;
        const { event } = this.props;
        const eventId = this.props.event.id;

        let isHostOrAdmin = false;
        Object.keys(this.props.user.events).map((key) => {
            if (this.props.user.events[key].id === eventId) {
                if (this.props.user.events[key].roles.includes(RolesSystem.HOST) || this.props.user.events[key].roles.includes(RolesSystem.ADMIN)) {
                    isHostOrAdmin = true;
                }
            }
        });

        return (
            <tr key={"event-" + event.id}>
                <td style={{ textAlign: 'center' }}>{this.props.index}</td>
                <td data-label="Event">
                    <Link to={RouteTo.eventPublic(this.props.event.id)}
                    >
                        {event.name}

                    </Link>
                </td>
                <td data-label="Location">
                    {event.location}
                </td>
                <td data-label="Date">
                    {
                        timeInfo === undefined ? null : String(timeInfo.startMonth) + '.' + String(timeInfo.startDay) + '.' + String(timeInfo.startYear) + ' ' +
                            String(timeInfo.startHour) + ':' + (timeInfo.startMinutes / 10 < 1 ? String(timeInfo.startMinutes) + '0' : String(timeInfo.startMinutes))
                    }
                    {timeInfo === undefined ? null : timeInfo.startAMPM ? 'PM' : 'AM'}
                </td>
                {
                    isHostOrAdmin ? <td data-label="Tickets" style={{textAlign: 'center'}} >{(Number(event.totalPrivate) + Number(event.totalPublic)) || 0}</td>
                              : <td data-label="Tickets" style={{textAlign: 'center'}} >{Number(event.totalPrivate) || 0}</td>           
                }
                <td data-label="Revenue" style={{ textAlign: 'center' }} >{Number(event.revenueTotal) ? '$' + Number((event.revenueTotal / 100)).toFixed(2) : 0}</td>
                <td style={{ textAlign: 'center' }}>

                    <UncontrolledDropdown>
                        <DropdownToggle nav={true} className='new-button-white-2'>
                            Options
			    </DropdownToggle>
                        <DropdownMenu right={true}>
                            <OnlyPromoter eventId={eventId}>

                                {/* DASHBOARD */}
                                <DropdownItem>
                                    <Link
                                        to={RouteTo.eventDetail(eventId)}
                                    >
                                        Dashboard
                            </Link>
                                </DropdownItem>
                            </OnlyPromoter>


                            {/* MANAGE */}
                            {this.props.isActive ? (
                                <OnlyHost eventId={eventId}>
                                    <DropdownItem>
                                        <Link
                                            to={RouteTo.eventEdit(eventId)}
                                        >
                                            Manage
                </Link>
                                    </DropdownItem>
                                </OnlyHost>
                            ) : (
                                    <OnlyAdmin eventId={eventId}>
                                        <DropdownItem>
                                            <Link
                                                to={RouteTo.eventEdit(eventId)}
                                            >
                                                Manage
                </Link>
                                        </DropdownItem>
                                    </OnlyAdmin>
                                )}


                            {/* CHECKIN */}
                            {
                                this.props.event.isActive ?
                                    <OnlyChecker eventId={eventId}>
                                        <DropdownItem>
                                            <Link
                                                to={RouteTo.eventCheckIn(eventId)}
                                            >
                                                CheckIn
                            </Link>
                                        </DropdownItem>
                                    </OnlyChecker>
                                    : null
                            }


                            {/* GENERATE TICKETS */}
                            {
                                this.props.event.isActive ?
                                    <OnlyPromoter eventId={eventId}>
                                        <DropdownItem>
                                            <Link
                                                to={"/manage/activate/digital/" + eventId}
                                            >
                                                Sell
                </Link>
                                        </DropdownItem>
                                    </OnlyPromoter>
                                    : null
                            }
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </td>
            </tr>
        )
    }
}

const mapStateToProps = state => ({
	user: UserDucks.getUser(state)
});

export default connect(mapStateToProps)(TableContent)


// WEBPACK FOOTER //
// ./src/pages/manage/events/manage/TableContent.tsx